export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
              type:'container',
              name: "Container Diferenciais",
              attributes: { class: 'container-cubo' },
              components: [
                {
                  type: 'columnsDifferences1',
                },
      
              ],
              styles: `
             .container{
                max-width: 1600px; 
             }
            `,
            },
          },
          view: {
      
          },
};
  return component; 
};